(function () {
  'use strict';

  function setExpanded(buttons, expanded) {
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var menuButton = document.querySelector('[data-nexa-menu-button]');
    var mobileMenu = document.getElementById('NexaMobileMenu');
    var searchButtons = document.querySelectorAll('[data-nexa-search-button]');
    var searchPanel = document.getElementById('NexaSearch');

    if (menuButton && mobileMenu) {
      menuButton.addEventListener('click', function () {
        var willOpen = mobileMenu.hasAttribute('hidden');
        if (willOpen) mobileMenu.removeAttribute('hidden');
        else mobileMenu.setAttribute('hidden', 'hidden');
        menuButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
      var menuLinks = mobileMenu.querySelectorAll('a');
      for (var m = 0; m < menuLinks.length; m++) {
        menuLinks[m].addEventListener('click', function () {
          mobileMenu.setAttribute('hidden', 'hidden');
          menuButton.setAttribute('aria-expanded', 'false');
        });
      }
    }

    for (var i = 0; i < searchButtons.length; i++) {
      searchButtons[i].addEventListener('click', function () {
        if (!searchPanel) return;
        var willOpen = searchPanel.hasAttribute('hidden');
        if (willOpen) {
          searchPanel.removeAttribute('hidden');
          if (mobileMenu) mobileMenu.setAttribute('hidden', 'hidden');
          if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
        } else {
          searchPanel.setAttribute('hidden', 'hidden');
        }
        setExpanded(searchButtons, willOpen);
        if (willOpen) {
          var input = searchPanel.querySelector('input[type="search"]');
          if (input) setTimeout(function () { input.focus(); }, 40);
        }
      });
    }
  });
})();
